import { render, staticRenderFns } from "./87.vue?vue&type=template&id=8a56dbf8&scoped=true&"
var script = {}
import style0 from "./87.vue?vue&type=style&index=0&id=8a56dbf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a56dbf8",
  null
  
)

export default component.exports